import React from 'react';
import Select from 'antd/lib/select';
import { UserOption } from '@client/lib/auth';
import styles from './UserPickerSelect.module.css';

type Props = {
	value?: number;
	disabled?: boolean;
	options: UserOption[];
	onChange: (value: number | undefined) => void;
};

const UserPickerSelect = ({
	value,
	disabled,
	options,
	onChange,
}: Props) => {
	return (
		<div className={styles.userSelectHeader}>
			<Select<number>
				allowClear
				disabled={disabled}
				variant="borderless"
				size="small"
				className={styles.userSelect}
				options={options}
				placeholder="Select user"
				value={value}
				onChange={(val) => onChange(val ?? undefined)}
			/>
		</div>
	);
};

export default UserPickerSelect;
